<template>
  <div class="add-form-wrap">
    <ankh-list :show-search-form="false">
      <template #btn-group>
        <el-button type="primary" @click.native="onAddRow">{{ $t('新增一行') }}</el-button>
        <el-button type="primary" @click.native="onQuickAddRows">{{ $t('快速新增行') }}</el-button>
        <el-button type="success" @click.native="onSave">{{ $t('保存') }}</el-button>
      </template>

      <template #table="{height}">
        <div class="table-scroll-x">
          <vxe-table
              :data="tableData"
              :height="height"
              border
              resizable
              :show-overflow="true"
              :show-header-overflow="true"
              :scroll-x="{enabled: true, gt: 20}"
              :scroll-y="{enabled: true, gt: 20}"
              :loading="loading"
          >
            <!-- 适用人群 -->
            <vxe-column title="适用人群" min-width="400" fixed="left">
              <template #default="{row}">
                <div class="age-range-input-row">
                  <el-input-number
                      v-model="row.minAge"
                      controls-position="right"
                      :precision="0"
                      @change="() => handleSyncVal('minAge', 'maxAge', row)"
                  />
                  <span class="range-separator">-</span>
                  <el-input-number
                      v-model="row.maxAge"
                      controls-position="right"
                      :precision="0"
                  />
                  <el-select
                      v-model="row.ageUnit"
                      style="width: 80px; margin-left: 8px;"
                      @change="() => onAgeUnitChange(row)"
                  >
                    <el-option label="岁" value="year" />
                    <el-option label="月" value="month" />
                  </el-select>
                </div>
              </template>
            </vxe-column>

            <!-- 营养元素 -->
            <vxe-column title="营养元素" min-width="150">
              <template #default="{row}">
                <el-select
                    v-model="row.refElement"
                    placeholder="请选择营养元素"
                    clearable
                    filterable
                >
                  <el-option v-for="opt in elList" :key="opt.flag" :label="opt.name" :value="opt.flag"/>
                </el-select>
              </template>
            </vxe-column>

            <!-- 性别 -->
            <vxe-column title="性别" min-width="120">
              <template #default="{row}">
                <el-select
                    v-model="row.gender"
                    placeholder="请选择性别"
                    clearable
                >
                  <el-option label="男" value="man"/>
                  <el-option label="女" value="woman"/>
                </el-select>
              </template>
            </vxe-column>

            <!-- 活动水平 -->
            <vxe-column title="活动水平" min-width="140">
              <template #default="{row}">
                <el-select
                    v-model="row.refLabor"
                    placeholder="请选择活动水平"
                    clearable
                    filterable
                >
                  <el-option v-for="opt in laborList" :key="opt.code" :label="opt.name" :value="opt.code"/>
                </el-select>
              </template>
            </vxe-column>

            <!-- 算法A -->
            <vxe-column title="算法A" min-width="120">
              <template #default="{row}">
                <el-select
                    v-model="row.refAlgorithm"
                    placeholder="请选择算法"
                    clearable
                    filterable
                >
                  <el-option v-for="opt in algorithmList" :key="opt.code" :label="opt.algo" :value="opt.code"/>
                </el-select>
              </template>
            </vxe-column>

            <!-- 算法B -->
            <vxe-column title="算法B" min-width="120">
              <template #default="{row}">
                <el-select
                    v-model="row.refAlgorithmMax"
                    placeholder="请选择算法"
                    clearable
                    filterable
                >
                  <el-option v-for="opt in algorithmList" :key="opt.code" :label="opt.algo" :value="opt.code"/>
                </el-select>
              </template>
            </vxe-column>

            <!-- PA值 -->
            <vxe-column title="PA值" min-width="180">
              <template #default="{row}">
                <el-input-number
                    v-model="row.pa"
                    controls-position="right"
                    placeholder="请输入PA值"
                    :precision="2"
                    :step="0.1"
                    :min="0"
                    :max="2"
                />
              </template>
            </vxe-column>

            <!-- 推荐摄入量 -->
            <vxe-column title="推荐摄入量" min-width="280" fixed="right">
              <template #default="{row}">
                <div class="range-input-row">
                  <el-input-number
                      v-model="row.min"
                      controls-position="right"
                      placeholder="最小值"
                      @change="() => handleSyncVal('min', 'max', row)"
                  />
                  <span class="range-separator">-</span>
                  <el-input-number
                      v-model="row.max"
                      controls-position="right"
                      placeholder="最大值"
                  />
                </div>
              </template>
            </vxe-column>

            <!-- 操作列 -->
            <vxe-column :title="$t('操作')" fixed="right" width="120">
              <template #default="{ $rowIndex }">
                <el-link :underline="false" type="danger" @click="onRemove($rowIndex)">{{ $t('删除') }}</el-link>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </template>
    </ankh-list>

    <!-- 快速新增行弹窗 -->
    <el-dialog
        :visible.sync="quickAddDialogVisible"
        :title="$t('快速新增行')"
        :close-on-click-modal="false"
        width="720px"
        @close="resetQuickAddDialog"
    >
      <el-form :model="quickAddForm" :rules="quickAddRules" ref="quickAddForm" label-width="100px">
        <!-- 新增行数 -->
        <el-form-item :label="$t('新增行数')" prop="rowCount">
          <el-input-number
              v-model="quickAddForm.rowCount"
              :min="1"
              :max="100"
              :placeholder="$t('请输入要新增的行数')"
              style="width: 200px;"
          />
        </el-form-item>

        <!-- 适用人群 -->
        <el-form-item label="适用人群">
          <div class="age-range-input-row">
            <el-input-number
                v-model="quickAddForm.minAge"
                controls-position="right"
                :precision="0"
                @change="() => handleSyncVal('minAge', 'maxAge', quickAddForm)"
            />
            <span class="range-separator">-</span>
            <el-input-number
                v-model="quickAddForm.maxAge"
                controls-position="right"
                :precision="0"
            />
            <el-select
                v-model="quickAddForm.ageUnit"
                style="width: 80px; margin-left: 8px;"
            >
              <el-option label="岁" value="year" />
              <el-option label="月" value="month" />
            </el-select>
          </div>
        </el-form-item>

        <!-- 营养元素 -->
        <el-form-item label="营养元素">
          <el-select
              v-model="quickAddForm.refElement"
              placeholder="请选择营养元素"
              clearable
              filterable
              style="width: 100%;"
          >
            <el-option v-for="opt in elList" :key="opt.flag" :label="opt.name" :value="opt.flag"/>
          </el-select>
        </el-form-item>

        <!-- 性别 -->
        <el-form-item label="性别">
          <el-select
              v-model="quickAddForm.gender"
              placeholder="请选择性别"
              clearable
              style="width: 100%;"
          >
            <el-option label="男" value="man"/>
            <el-option label="女" value="woman"/>
          </el-select>
        </el-form-item>

        <!-- 活动水平 -->
        <el-form-item label="活动水平">
          <el-select
              v-model="quickAddForm.refLabor"
              placeholder="请选择活动水平"
              clearable
              filterable
              style="width: 100%;"
          >
            <el-option v-for="opt in laborList" :key="opt.code" :label="opt.name" :value="opt.code"/>
          </el-select>
        </el-form-item>

        <!-- 算法A -->
        <el-form-item label="算法A">
          <el-select
              v-model="quickAddForm.refAlgorithm"
              placeholder="请选择算法"
              clearable
              filterable
              style="width: 100%;"
          >
            <el-option v-for="opt in algorithmList" :key="opt.code" :label="opt.algo" :value="opt.code"/>
          </el-select>
        </el-form-item>

        <!-- 算法B -->
        <el-form-item label="算法B">
          <el-select
              v-model="quickAddForm.refAlgorithmMax"
              placeholder="请选择算法"
              clearable
              filterable
              style="width: 100%;"
          >
            <el-option v-for="opt in algorithmList" :key="opt.code" :label="opt.algo" :value="opt.code"/>
          </el-select>
        </el-form-item>

        <!-- PA值 -->
        <el-form-item label="PA值">
          <el-input-number
              v-model="quickAddForm.pa"
              controls-position="right"
              placeholder="请输入PA值"
              :precision="2"
              :step="0.1"
              :min="0"
              :max="2"
              style="width: 100%;"
          />
        </el-form-item>

        <!-- 推荐摄入量 -->
        <el-form-item label="推荐摄入量">
          <div class="range-input-row">
            <el-input-number
                v-model="quickAddForm.min"
                controls-position="right"
                placeholder="最小值"
                @change="() => handleSyncVal('min', 'max', quickAddForm)"
                style="flex: 1;"
            />
            <span class="range-separator">-</span>
            <el-input-number
                v-model="quickAddForm.max"
                controls-position="right"
                placeholder="最大值"
                style="flex: 1;"
            />
          </div>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="quickAddDialogVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="primary" @click="handleQuickAddSubmit">{{ $t('确定') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import AnkhList from '@/components/list/AnkhList.vue'
import { request } from '@/config/request'

export default {
  name: 'RecommendConfigAddT',
  components: { AnkhList },
  data() {
    return {
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 快速新增行弹窗相关
      quickAddDialogVisible: false,
      quickAddForm: {},
      quickAddRules: {
        rowCount: [
          { required: true, message: this.$t('请输入新增行数'), trigger: 'blur' },
          { type: 'number', min: 1, max: 100, message: this.$t('行数必须在1-100之间'), trigger: 'blur' }
        ]
      },
      // 关联数据源
      elList: [],
      laborList: [],
      algorithmList: [],
    }
  },
  created() {
    // 初始化一行空数据
    this.tableData = [this.buildEmptyRow()]
    // 加载关联数据
    this.loadAllOptions()
  },
  methods: {
    // 构建空行数据
    buildEmptyRow() {
      return {
        minAge: null,
        maxAge: null,
        ageUnit: 'year',
        refElement: '',
        gender: '',
        refLabor: '',
        refAlgorithm: '',
        refAlgorithmMax: '',
        pa: null,
        min: null,
        max: null
      }
    },

    // 填写最小值后需用同步到最大值（通用方法）
    handleSyncVal(valKey, key, row) {
      row[key] = row[valKey]
    },

    // 年龄单位变化时的处理
    onAgeUnitChange(row) {
      const unit = row.ageUnit
      const minVal = row.minAge
      const maxVal = row.maxAge

      // 如果切换到月单位，检查数值是否超出1-12范围
      if (unit === 'month') {
        // 如果最小值超出范围，重置为1
        if (minVal !== null && minVal !== undefined && (minVal < 1 || minVal > 12)) {
          row.minAge = 1
        }
        // 如果最大值超出范围，重置为12
        if (maxVal !== null && maxVal !== undefined && (maxVal < 1 || maxVal > 12)) {
          row.maxAge = 12
        }
        // 如果最小值大于最大值，调整最大值
        if (minVal !== null && minVal !== undefined && maxVal !== null && maxVal !== undefined && minVal > maxVal) {
          row.maxAge = minVal
        }
      }
    },

    // 新增按钮点击事件
    onAddRow() {
      const newRow = this.buildEmptyRow()
      this.tableData.push(newRow)
    },

    // 快速新增行按钮点击事件
    onQuickAddRows() {
      this.quickAddDialogVisible = true
      this.initQuickAddForm()
    },

    // 初始化快速新增表单
    initQuickAddForm() {
      this.quickAddForm = {
        rowCount: 1,
        minAge: null,
        maxAge: null,
        ageUnit: 'year',
        refElement: '',
        gender: '',
        refLabor: '',
        refAlgorithm: '',
        refAlgorithmMax: '',
        pa: null,
        min: null,
        max: null
      }
    },

    // 重置快速新增弹窗
    resetQuickAddDialog() {
      this.quickAddForm = {}
      this.$nextTick(() => {
        if (this.$refs.quickAddForm) {
          this.$refs.quickAddForm.clearValidate()
        }
      })
    },

    // 处理快速新增提交
    handleQuickAddSubmit() {
      this.$refs.quickAddForm.validate((valid) => {
        if (valid) {
          const rowCount = this.quickAddForm.rowCount
          const newRows = []

          // 生成指定数量的行
          for (let i = 0; i < rowCount; i++) {
            const newRow = this.buildRowFromQuickAddForm()
            newRows.push(newRow)
          }

          // 批量添加到表格
          this.tableData.push(...newRows)

          this.$message.success(this.$t('成功新增') + ` ${rowCount} ` + this.$t('行数据'))
          this.quickAddDialogVisible = false
        }
      })
    },

    // 根据快速新增表单生成新行数据
    buildRowFromQuickAddForm() {
      return {
        minAge: this.quickAddForm.minAge,
        maxAge: this.quickAddForm.maxAge,
        ageUnit: this.quickAddForm.ageUnit,
        refElement: this.quickAddForm.refElement,
        gender: this.quickAddForm.gender,
        refLabor: this.quickAddForm.refLabor,
        refAlgorithm: this.quickAddForm.refAlgorithm,
        refAlgorithmMax: this.quickAddForm.refAlgorithmMax,
        pa: this.quickAddForm.pa,
        min: this.quickAddForm.min,
        max: this.quickAddForm.max
      }
    },

    // 删除按钮点击事件
    onRemove(index) {
      this.$confirm(this.$t('确认删除该行吗？'), this.$t('提示'), { type: 'warning' }).then(() => {
        this.tableData.splice(index, 1)
      }).catch(() => {})
    },

    // 保存按钮点击事件
    async onSave() {
      // 先做基础必填校验
      for (let i = 0; i < this.tableData.length; i++) {
        const row = this.tableData[i]

        // 校验必填字段
        if (!row.refElement) {
          this.$message.error(this.$t('第') + `${i + 1}` + this.$t('行') + `【营养元素】` + this.$t('为必填项'))
          return
        }
        // if (!row.gender) {
        //   this.$message.error(this.$t('第') + `${i + 1}` + this.$t('行') + `【性别】` + this.$t('为必填项'))
        //   return
        // }
        // if (!row.refLabor) {
        //   this.$message.error(this.$t('第') + `${i + 1}` + this.$t('行') + `【活动水平】` + this.$t('为必填项'))
        //   return
        // }

        // 特殊校验：PA值范围校验
        // if (row.pa !== null && row.pa !== undefined) {
        //   if (row.pa < 0 || row.pa > 2) {
        //     this.$message.error(this.$t('第') + `${i + 1}` + this.$t('行') + `【PA值】` + this.$t('应在0-2之间'))
        //     return
        //   }
        // }

        // 校验年龄范围
        if (row.minAge !== null && row.minAge !== undefined && row.maxAge !== null && row.maxAge !== undefined) {
          if (Number(row.minAge) > Number(row.maxAge)) {
            this.$message.error(this.$t('第') + `${i + 1}` + this.$t('行') + `【适用人群】` + this.$t('最小值不能大于最大值'))
            return
          }
        }

        // 校验推荐摄入量范围
        if (row.min !== null && row.min !== undefined && row.max !== null && row.max !== undefined) {
          if (Number(row.min) > Number(row.max)) {
            this.$message.error(this.$t('第') + `${i + 1}` + this.$t('行') + `【推荐摄入量】` + this.$t('最小值不能大于最大值'))
            return
          }
        }
      }

      // 构建最终保存数据：转换为后端期望的数据结构
      const payload = this.convertDisplayDataToBackend(this.tableData)

      try {
        // 调用保存接口
        await this.saveNutriRecommendData(payload)
        this.$message.success(this.$t('保存成功'))
        this.$router.back()
      } catch (e) {
        console.error('保存失败:', e)
        this.$message.error('保存失败')
      }
    },

    // 将页面显示数据转换为后端期望的数据结构
    convertDisplayDataToBackend(displayData) {
      return displayData.map(srcRow => {
        // 深拷贝，避免直接修改页面数据
        const row = JSON.parse(JSON.stringify(srcRow))

        // 自动添加推荐值code（从路由参数获取）
        row.refRecommend = this.$route.query.code || ''

        // 处理适用年龄字段：将"年"统一换算为"月"
        if (row.minAge !== null && row.minAge !== undefined) {
          const minAge = Number(row.minAge)
          row.minAge = row.ageUnit === 'year' ? minAge * 12 : minAge
        }
        if (row.maxAge !== null && row.maxAge !== undefined) {
          const maxAge = Number(row.maxAge)
          row.maxAge = row.ageUnit === 'year' ? maxAge * 12 : maxAge
        }
        delete row.ageUnit

        return row
      })
    },

    // 保存数据到后端
    async saveNutriRecommendData(payload) {
      await request(this.$api.nutriRecommend.batchAdd, payload, {isJson: true});
    },

    // 营养元素
    async loadEl() {
      try {
        const res = await request(this.$api.elementSort.list, {onPage: false, refRecommend: this.$route.query.code})
        this.elList = res.elementSorts
      } catch (err) {
        console.error(err)
      }
    },

    // 活动水平
    async loadLabor() {
      try {
        const res = await request(this.$api.labor.list, {onPage: false, refRecommend: this.$route.query.code})
        this.laborList = res.labors
      } catch (err) {
        console.error(err)
      }
    },

    // 算法
    async loadAlgorithm() {
      try {
        const res = await request(this.$api.algo.list, {onPage: false, refRecommend: this.$route.query.code})
        this.algorithmList = res.algos || []
      } catch (err) {
        console.error(err)
      }
    },

    // 汇总资源请求统一
    async loadAllOptions() {
      await Promise.all([
        this.loadEl(),
        this.loadLabor(),
        this.loadAlgorithm(),
      ])
    },
  }
}
</script>

<style scoped>
.add-form-wrap {
  width: 100%;
}

.table-scroll-x {
  overflow-x: auto;
}

.table-scroll-x .vxe-table {
  min-width: 720px; /* 兜底最小宽度，确保出现横向滚动 */
}

.range-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.age-range-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-separator {
  color: #909399;
  margin: 0 4px;
}

.range-unit {
  color: #606266;
  margin-left: 4px;
}

/* 表格滚动条样式优化 */
.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar {
  height: 8px;
}

.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.el-select {
  width: 100%;
}

/* 小屏幕优化 */
@media (max-width: 768px) {
  .age-range-input-row {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }

  .age-range-input-row .el-input-number {
    width: 100%;
  }

  .age-range-input-row .el-select {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .range-input-row {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }

  .range-input-row .el-input-number {
    width: 100%;
  }
}
</style>
